import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { COMPANY_INFO } from '../data/company';

export default function NotFoundPage() {
  return (
    <>
      <Helmet>
        <title>Side ikke fundet (404) - OP Rengøringsservice</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <section className="min-h-[70vh] flex items-center justify-center py-20 bg-slate-50">
        <div className="max-w-2xl mx-auto px-4 text-center">
          <div className="w-20 h-20 mx-auto rounded-full bg-sky-100 text-sky-800 flex items-center justify-center text-3xl font-extrabold mb-6 shadow-inner">
            404
          </div>

          <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight mb-3">
            Siden blev desværre ikke fundet
          </h1>

          <p className="text-slate-600 text-base leading-relaxed mb-8 max-w-md mx-auto">
            Den side, du leder efter, eksisterer ikke eller er blevet flyttet. Brug venligst et af nedenstående links for at komme videre.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-4 mb-10">
            <Link
              to="/"
              className="inline-flex items-center gap-2 bg-sky-800 hover:bg-sky-900 text-white font-bold py-3 px-6 rounded-xl shadow transition-colors text-sm"
            >
              <i className="fa-solid fa-house" aria-hidden="true" />
              <span>Gå til forside</span>
            </Link>

            <Link
              to="/ydelser"
              className="inline-flex items-center gap-2 bg-slate-200 hover:bg-slate-300 text-slate-800 font-bold py-3 px-6 rounded-xl transition-colors text-sm"
            >
              <i className="fa-solid fa-sparkles text-sky-700" aria-hidden="true" />
              <span>Rengøringsydelser</span>
            </Link>

            <Link
              to="/kontakt"
              className="inline-flex items-center gap-2 bg-emerald-600 hover:bg-emerald-500 text-white font-bold py-3 px-6 rounded-xl transition-colors text-sm"
            >
              <i className="fa-solid fa-envelope" aria-hidden="true" />
              <span>Kontakt os</span>
            </Link>
          </div>

          <div className="pt-8 border-t border-slate-200 text-sm text-slate-600">
            <span>Har du brug for direkte assistance? Ring til os på </span>
            <a
              href={`tel:${COMPANY_INFO.phoneRaw}`}
              className="font-bold text-slate-900 hover:text-emerald-600 underline whitespace-nowrap-custom"
            >
              {COMPANY_INFO.phone}
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
